import React, { useState } from "react";

import { DatePicker, DateRangePicker } from "@mantine/dates";
import dayjs from "dayjs";

const CustomDatePicker = ({ date, onChange, label, tripType }: any) => {
  const [value, setValue] = useState(date);
  const handleValueChange = (newValue: any) => {
    console.log("newValue:", newValue);
    onChange(newValue);
    setValue(newValue);
  };

  return (
    <>
      {tripType === "Round-trip" ? (
        <DateRangePicker
          variant="unstyled"
          locale="fr"
          label={label}
          placeholder="Choisir la/les date(s)"
          value={value}
          inputFormat="DD/MM/YYYY"
          onChange={handleValueChange}
          amountOfMonths={2}
          minDate={dayjs(new Date()).add(1).toDate()}
          clearable={false}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            width: "inherit",
            height: "inherit",
            border: "1px solid #eeeeee",
            borderRadius: "5px",
            backgroundColor: "#eeeeee",
            padding: "5px",
            "&: hover": {
              backgroundColor: "#D2E6F1",
              color: "whitesmoke",
            },
            "&: focus": {
              backgroundColor: "#D2E6F1",
              color: "whitesmoke",
            },
          }}
        />
      ) : (
        <DatePicker
          variant="unstyled"
          locale="fr"
          dropdownType="popover"
          clearable={false}
          placeholder={value}
          label={label}
          inputFormat="DD/MM/YYYY"
          value={value}
          minDate={dayjs(new Date()).add(1).toDate()}
          onChange={handleValueChange}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            width: "inherit",
            height: "inherit",
            border: "1px solid #eeeeee",
            borderRadius: "5px",
            backgroundColor: "#eeeeee",
            padding: "5px",
            "&: hover": {
              backgroundColor: "#D2E6F1",
              color: "whitesmoke",
            },
            "&: focus": {
              backgroundColor: "#D2E6F1",
              color: "whitesmoke",
            },
          }}
        />
      )}
    </>
  );
};

export default CustomDatePicker;
